import React, { FC } from 'react';
import { Header, SideNav, SupportMenu, UserMenu } from '@liveoptics/react-ui';
import styled from '@emotion/styled';
import { Config } from '../use-config/models/Config';
import '../css/calc-custom.scss';
import lo from '../svgs/live_optics.svg';
import Nav from './Nav';
import Footer from './Footer';

const Layout = styled.div`
  position: relative;
  background: #f2f2f2;
`;

const HeaderWrapper = styled.div`
  position: fixed;
  width: 100%;
  z-index: 10;
`;

const Content = styled.div`
  min-height: 100%;
  height: 100%;
  padding-top: 20px;
  padding-left: 50px;
  padding-right: 50px;
  padding-bottom: 4.8rem;
`;

const FooterWrapper = styled.footer`
  position: absolute;
  left: 3rem;
  right: 0;
  bottom: 0;
`;

interface DashboardProps {
  config: Config;
}

const Dashboard: FC<DashboardProps> = (props) => {
  const { config } = props;
  const id = 123;
  return (
    <Layout>
      {/* <Nav /> */}
      <Content id="calc-content-wrapper" className="calc-content-wrapper">
        {props.children}
      </Content>
      <Footer />
    </Layout>
  );
};

export default Dashboard;
